export default __webpack_public_path__ + "static/media/taggedImg5.833f114c.jpeg";